module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Granville Affair")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "title_page"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/title_page"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#part-one"
    }
  }, [_vm._v("Part One")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#shadows-of-destiny"
    }
  }, [_vm._v("Shadows of Destiny")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#section"
    }
  }, [_vm._v("1939–1940")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#one"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch003#two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#part-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#aspects-of-austerity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aspects of Austerity")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#section-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1940–1942")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#five",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#part-three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#into-the-light",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Light")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#section-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1943–1945")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#six",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#seven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-granville-sisters-trilogy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Granville Sisters Trilogy")])]), _vm._v(" "), _c('li', {
    staticClass: "author_bio"
  }, [_c('span', {
    attrs: {
      "href": "#/text/author_bio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    staticClass: "also_by"
  }, [_c('span', {
    attrs: {
      "href": "#/text/also_by",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Una-Mary Parker")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden",
      "id": "landmarks"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/nav#toc"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/title_page"
    }
  }, [_vm._v("Start of Content")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 57
// module chunks = 0